import _get from 'lodash/get'
import _find from 'lodash/find'
import _isEmpty from 'lodash/isEmpty'

import fhirConfigReader from '../readers/fhirConfig'

const refreshEpicToken = (epicFhirConfig, refreshToken) => {
  const url = fhirConfigReader.url(epicFhirConfig)
  const clientSecret = fhirConfigReader.clientSecret(epicFhirConfig)

  const headers = new Headers()
  headers.append('Content-Type', 'application/x-www-form-urlencoded')
  headers.append('Authorization', `Basic ${clientSecret}`)

  const urlencoded = new URLSearchParams()
  urlencoded.append('grant_type', 'refresh_token')
  urlencoded.append('refresh_token', refreshToken)

  return fetch(url, {
    method: 'POST',
    headers,
    body: urlencoded
  }).then((response) => response.json())
}

const isCernerTokenEndPoint = ({ url }) => url === 'token'

const fetchCernerRefreshTokenTokenUrl = (cernerFhirConfig) => {
  const url = fhirConfigReader.url(cernerFhirConfig)
  const spec = fhirConfigReader.spec(cernerFhirConfig)
  const tenantId = fhirConfigReader.tenantId(cernerFhirConfig)

  const metadataUrl = `${url}/${spec}/${tenantId}/metadata`

  const headers = new Headers()
  headers.append('Accept', 'application/json')

  return fetch(metadataUrl, {
    headers
  })
    .then((response) => response.json())
    .then((response) => {
      const restEndPoints = _get(
        response,
        'rest.0.security.extension.0.extension',
        []
      )
      const { valueUri } = _find(restEndPoints, isCernerTokenEndPoint) || {}
      return valueUri
    })
    .catch((error) => {
      console.log(
        '[EMR Token Refresh]: Failed fetch refresh token url from metadata',
        error
      )
    })
}

const refreshCernerToken = async (cernerFhirConfig, refreshToken) => {
  const tokenRefreshUrl = await fetchCernerRefreshTokenTokenUrl(
    cernerFhirConfig
  )
  if (_isEmpty(tokenRefreshUrl)) {
    throw new Error()
  }
  const urlencoded = new URLSearchParams()
  urlencoded.append('grant_type', 'refresh_token')
  urlencoded.append('refresh_token', refreshToken)

  const headers = new Headers()
  headers.append('Content-Type', 'application/x-www-form-urlencoded')
  headers.append('Accept', 'application/json')
  headers.append('Connection', 'close')
  headers.append('Content-Length', urlencoded.toString().length)

  return fetch(tokenRefreshUrl, {
    method: 'POST',
    headers,
    body: urlencoded
  }).then((response) => response.json())
}

export default {
  refreshEpicToken,
  refreshCernerToken
}
